import { render, staticRenderFns } from "./handle.vue?vue&type=template&id=6fd49379&scoped=true&"
import script from "./handle.vue?vue&type=script&lang=js&"
export * from "./handle.vue?vue&type=script&lang=js&"
import style0 from "./handle.vue?vue&type=style&index=0&id=6fd49379&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd49379",
  null
  
)

export default component.exports